module.exports = __webpack_public_path__ + "static/media/giftsSent_500_750.e0e8a12a.png";